import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tab from './Tab';
import './index.scss';

class Tabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: props.children[0].props.label
        };

        this.onClickTabItem = this.onClickTabItem.bind(this);
    }

    onClickTabItem(tab, childProps) {
        this.setState({ activeTab: tab }, () => this.props.onChange(childProps));
    }

    render() {
        const {
            onClickTabItem,
            props: { children },
            state: { activeTab }
        } = this;
        const hasTabs = children.length > 1;

        return (
            <div className={classnames(['FUI-tabs', {'has-tabs': hasTabs}])}>
                {hasTabs && <ol className="tab-list">
                    {children.map((child) => (
                        <Tab active={activeTab === child.props.label}
                            key={child.props.label}
                            label={child.props.label}
                            onClick={(tab) => onClickTabItem(tab, child.props)}/>
                    ))}
                </ol>}
                <div className="tab-content">
                    {children.map((child) =>
                        child.props.label === activeTab ? child.props.children : null
                    )}
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    children: PropTypes.instanceOf(Array).isRequired
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/common/WideGig/Tabs/index.js